import { SxProps } from '@mui/material';

export const DrawerRegisterFrameSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	height: 'auto',
	maxHeight: '90vh',
	position: 'fixed',
	bottom: 0,
	left: 0,
	right: 0,
	zIndex: 1000,
	borderTopLeftRadius: '10px',
	borderTopRightRadius: '10px',
	paddingTop: '5px',
};

export const DrawerRegisterHeaderIconBackSx: SxProps = {
	fontSize: 'var(--font-size-xl)',
};

export const DrawerRegisterHeaderIconCloseSx: SxProps = {
	fontSize: '1.8rem',
};

export const DrawerRegisterContentSx: SxProps = {
	padding: '0px 25px 25px 25px',
	width: '100%',
	height: '70vh',
	overflowY: 'auto',
};

export const DrawerRegisterTitleSx: SxProps = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: 800,
};

export const DrawerRegisterDescriptionSx: SxProps = {
	fontSize: 'var(--font-size-sm)',
	marginBottom: '20px',
};

export const DrawerRegisterHeaderIconBackFrameSx: SxProps = { margin: 0, paddingLeft: '25px' };
